import { createBrowserRouter, Navigate } from 'react-router-dom';
import PublicLayout from '../layouts/PublicLayout';
import Homepage from '../screens/HomePage';
import Login from '../screens/Login';
import Register from '../screens/Register';
import ProtectedRoute from '../components/ProtectedRoute';
import StudentLayout from '../layouts/StudentLayout';
import GuardianDashboard from '../components/dashboard/GuardianDashboard';
import GuardianStudents from '../components/guardian/GuardianStudents';
import GuardianStudent from '../components/guardian/GuardianStudent';
import TeacherDashboard from '../components/dashboard/TeacherDashboard';
import TeacherCourses from '../components/teacher/TeacherCourses';
import TeacherCourse from '../components/teacher/TeacherCourse';
import TeacherSchedule from '../components/teacher/TeacherSchedule';
import TeacherStudents from '../components/teacher/TeacherStudents';
import SchoolDashboard from '../components/dashboard/SchoolDashboard';
import StudentDashboard from '../components/dashboard/StudentDashboard';
import StudentCourses from '../components/student/StudentCourses';
import StudentProgress from '../components/student/StudentProgress';
import NotFound from '../components/NotFound';
import Schedule from '../screens/Schedule';
import SchoolTeachers from '../screens/School/SchoolTeachers';
import SchoolVerifications from '../screens/School/SchoolVerifications';
import SchoolClasses from '../screens/School/SchoolClasses';
import ConsoleLayout from '../layouts/ConsoleLayout';
import TeacherReports from '../components/teacher/reports/TeacherReports';
// import Pricing from '../screens/Pricing';
import Payment from '../screens/Payment';
import Withdrawals from '../screens/Withdrawals';
import GuardianProfiles from '../screens/guardian/GuardianProfiles';
import TeacherProfile from '../components/teacher/TeacherProfile';
import GuardianProfile from '../components/guardian/GuardianProfile';
import StudentProfile from '../components/student/StudentProfile';
import TeacherTeachingPlans from '../components/teacher/TeacherTeachingPlans';
import GuardianReports from '../screens/guardian/GuardianReports';
import GuardianSettings from '../screens/guardian/GuardianSettings';
import SchoolAdminProfile from '../components/school/SchoolAdminProfile';
import AboutPage from '../screens/AboutPage';
import TermsOfServicePage from '../screens/TermsOfServicePage';
import PrivacyPolicyPage from '../screens/PrivacyPolicyPage';

export const router = createBrowserRouter([
  // Public Routes
  {
    path: '/',
    element: <PublicLayout />,
    children: [
      { path: '', element: <Homepage /> },
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      //   { path: 'pricing', element: <Pricing /> },
      {
        path: 'legal',
        children: [
          { path: 'terms', element: <TermsOfServicePage /> },
          { path: 'privacy', element: <PrivacyPolicyPage /> }
        ]
      },
      //   { path: 'contact', element: <Contact /> },
      { path: 'about', element: <AboutPage /> }

    ]
  },

  // Protected Routes - Guardian Console
  {
    path: '/guardian',
    element: (
      <ProtectedRoute userType="guardian">
        <ConsoleLayout role="guardian" />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <GuardianDashboard /> },
      { path: 'students', element: <GuardianStudents /> },
      { path: 'profiles', element: <GuardianProfiles /> },
      { path: 'students/:studentId', element: <GuardianStudent /> },
      { path: 'profile', element: <GuardianProfile /> },
      // { path: 'payments', element: <GuardianPayments /> },
      { path: 'reports', element: <GuardianReports /> },
      { path: 'settings', element: <GuardianSettings /> }
    ]
  },

  // Protected Routes - Teacher Console
  {
    path: '/teacher',
    element: (
      <ProtectedRoute userType="teacher">
        <ConsoleLayout role="teacher" />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <TeacherDashboard /> },
      { path: 'schedule', element: <TeacherSchedule /> },
      { path: 'courses', element: <TeacherCourses /> },
      { path: 'courses/:courseId', element: <TeacherCourse /> },
      // { path: 'plans', element: <TeacherTeachingPlans /> },
      // { path: 'students', element: <TeacherStudents /> },
      { path: 'withdrawals', element: <Withdrawals /> },
      { path: 'reports', element: <TeacherReports /> },
      { path: 'profile', element: <TeacherProfile /> },
      // {
      //   path: 'assignments',
      //   children: [
      //     { path: '', element: <AssignmentsList /> },
      //     { path: 'create', element: <CreateAssignment /> },
      //     { path: ':assignmentId', element: <AssignmentDetails /> }
      //   ]
      // },
      // { path: 'reports', element: <TeacherReports /> },
      // { path: 'settings', element: <TeacherSettings /> }
    ]
  },

  // Protected Routes - School Console
  {
    path: '/school',
    element: (
      <ProtectedRoute userType="school">
        <ConsoleLayout role="school" />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <SchoolDashboard /> },
      { path: 'teachers', element: <SchoolTeachers /> },
      // { path: 'classes', element: <SchoolClasses /> },
      { path: 'verifications', element: <SchoolVerifications /> },
      { path: 'withdrawals', element: <Withdrawals /> },
      { path: 'profile', element: <SchoolAdminProfile /> }
      // {
      //   path: 'teachers',
      //   children: [
      //     { path: '', element: <TeachersList /> },
      //     { path: 'add', element: <AddTeacher /> },
      //     { path: ':teacherId', element: <TeacherProfile /> }
      //   ]
      // },
      // {
      //   path: 'students',
      //   children: [
      //     { path: '', element: <StudentsList /> },
      //     { path: 'add', element: <AddStudent /> },
      //     { path: ':studentId', element: <StudentProfile /> }
      //   ]
      // },
      // { path: 'classes', element: <SchoolClasses /> },
      // { path: 'reports', element: <SchoolReports /> },
      // { path: 'billing', element: <SchoolBilling /> },
      // { path: 'settings', element: <SchoolSettings /> }
    ]
  },

  // Protected Routes - Student Console
  {
    path: '/student',
    element: (
      <ProtectedRoute userType="student">
        <ConsoleLayout role="student" />
      </ProtectedRoute>
    ),
    children: [
      { path: '', element: <StudentDashboard /> },
      { path: 'courses', element: <StudentCourses /> },
      { path: 'progress', element: <StudentProgress /> },
      { path: 'payments', element: <Payment /> },
      // { path: 'progress', element: <StudentProgress /> },
      // { path: 'settings', element: <StudentSettings /> }
      { path: 'profile', element: <StudentProfile /> }
    ]
  },

  // Catch-all route for 404
  {
    path: '*',
    element: <NotFound />
  }
]); 